module.exports = __webpack_public_path__ + "static/img/h2-1.8f93bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd128/h2-1.png
// module id = uUa8
// module chunks = 1